import { render, staticRenderFns } from "./OnDemandSearching.vue?vue&type=template&id=1afb3f78&scoped=true&"
import script from "./OnDemandSearching.vue?vue&type=script&lang=js&"
export * from "./OnDemandSearching.vue?vue&type=script&lang=js&"
import style0 from "./OnDemandSearching.vue?vue&type=style&index=0&id=1afb3f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb3f78",
  null
  
)

export default component.exports